import { call, put, takeLatest } from "redux-saga/effects";
import * as actionTypes from "../ActionTypes";
import {
  saveCampusSuccess,
  saveCampusFailure,
  updateCampusSuccess,
  updateCampusFailure,
  deleteCampusSuccess,
  deleteCampusFailure,
  saveCampusGallerySuccess,
  saveCampusGalleryFailure,
  updateCampusGallerySuccess,
  updateCampusGalleryFailure,
  deleteCampusGallerySuccess, deleteCampusGalleryFailure
} from "./campusesActions";
import { saveCampus, updateCampus, deleteCampus, saveCampusGallery,updateCampusGallery,deleteCampusGallery } from "./campuses";

// 🔹 Save Campus Saga
function* saveCampusSaga(action) {
  try {
    const { apiPayloadRequest } = action.payload;
    const data = yield call(saveCampus, apiPayloadRequest);

    if (data?.type === 1) {
      const result = { ...apiPayloadRequest, ...data.data, campusObjId: data.campusObjId };
      yield put(saveCampusSuccess(result));
      action.callback?.({ type: 1, data: result });
    } else {
      yield put(saveCampusFailure(data?.error || "Save failed"));
      action.callback?.({ type: 0, error: data?.error });
    }
  } catch (error) {
    yield put(saveCampusFailure(error.message));
    action.callback?.({ type: 0, error: error.message });
  }
}

// 🔹 Update Campus Saga
function* updateCampusSaga(action) {
  try {
    const { apiPayloadRequest } = action.payload;
    const data = yield call(updateCampus, apiPayloadRequest);
    if (data?.type === 1) {
      yield put(updateCampusSuccess(apiPayloadRequest));
      action.callback?.({ type: 1, message: "Campus updated successfully" });
    } else {
      yield put(updateCampusFailure(data?.message || "Update failed"));
      action.callback?.({ type: 0, message: data?.message || "Update failed" });
    }
  } catch (error) {
    yield put(updateCampusFailure(error.message));
    action.callback?.({ type: 0, message: error.message });
  }
}

// 🔹 Delete Campus Saga
function* deleteCampusSaga(action) {
  try {
    const { apiPayloadRequest } = action.payload;
    const data = yield call(deleteCampus, apiPayloadRequest);
    if (data?.type === 1) {
      yield put(deleteCampusSuccess(apiPayloadRequest));
      action.callback?.({ type: 1, message: "Deleted successfully" });
    } else {
      yield put(deleteCampusFailure(data?.message || "Delete failed"));
      action.callback?.({ type: 0, message: data?.message || "Delete failed" });
    }
  } catch (error) {
    yield put(deleteCampusFailure(error.message));
    action.callback?.({ type: 0, message: error.message });
  }
}

// 🔹 Save Campus Gallery Saga
function* saveCampusGallerySaga(action) {
  try {
    const { apiPayloadRequest } = action.payload;
    const data = yield call(saveCampusGallery, apiPayloadRequest);

    if (data?.type === 1) {
      yield put(saveCampusGallerySuccess(data.data));
      action.callback?.({ type: 1, message: "Gallery saved successfully" });
    } else {
      yield put(saveCampusGalleryFailure(data?.message || "Gallery save failed"));
      action.callback?.({ type: 0, message: data?.message || "Gallery save failed" });
    }
  } catch (error) {
    yield put(saveCampusGalleryFailure(error.message));
    action.callback?.({ type: 0, message: error.message });
  }
}
function* updateCampusGallerySaga(action) {
  try {
    const { apiPayloadRequest } = action.payload;
    const data = yield call(updateCampusGallery, apiPayloadRequest);

    if (data?.type === 1) {
      // Pass all relevant fields so reducer updates state correctly
      const result = {
        ...apiPayloadRequest,
        ...data.data,
        campusGalleryObjId:
          data.campusGalleryObjId || apiPayloadRequest.campusGalleryObjId,
      };
      yield put(updateCampusGallerySuccess(result));
      action.callback?.({ type: 1, message: "Gallery updated successfully" });
    } else {
      yield put(updateCampusGalleryFailure(data?.message || "Gallery update failed"));
      action.callback?.({ type: 0, message: data?.message });
    }
  } catch (error) {
    yield put(updateCampusGalleryFailure(error.message));
    action.callback?.({ type: 0, message: error.message });
  }
}
function* deleteCampusGallerySaga(action) {
  try {
    const { apiPayloadRequest } = action.payload;
    const data = yield call(deleteCampusGallery, apiPayloadRequest);


    if (data?.type === 1) {
      yield put(deleteCampusGallerySuccess(apiPayloadRequest));

      // ✅ Fire callback after Redux update
      if (typeof action.callback === "function") {
        action.callback({ type: 1, message: "Campus gallery deleted successfully" });
      }

    } else {
      yield put(deleteCampusGalleryFailure(data?.message || "Gallery delete failed"));
      if (typeof action.callback === "function") {
        action.callback({ type: 0, error: data?.message || "Gallery delete failed" });
      }
    }
  } catch (error) {
    yield put(deleteCampusGalleryFailure(error.message));
    if (typeof action.callback === "function") {
      action.callback({ type: 0, error: error.message });
    }
  }
}

export default function* campusesWatcherSaga() {
  yield takeLatest(actionTypes.SAVE_CAMPUS_REQUEST, saveCampusSaga);
  yield takeLatest(actionTypes.UPDATE_CAMPUS_REQUEST, updateCampusSaga);
  yield takeLatest(actionTypes.DELETE_CAMPUS_REQUEST, deleteCampusSaga);
  yield takeLatest(actionTypes.SAVE_CAMPUS_GALLERY_REQUEST, saveCampusGallerySaga);
  yield takeLatest(actionTypes.UPDATE_CAMPUS_GALLERY_REQUEST, updateCampusGallerySaga);
  yield takeLatest(actionTypes.DELETE_CAMPUS_GALLERY_REQUEST, deleteCampusGallerySaga);


}
